import { dbsKeys } from "data/dbsKeys";
import { readCollection, writeCollection } from "data/dbsStorage";

const EMPTY = [];

export const provincesRepo = {
  list() {
    return readCollection(dbsKeys.provinces, EMPTY);
  },

  getById(id) {
    return provincesRepo.list().find((p) => p.id === id) || null;
  },

  create(province) {
    const items = provincesRepo.list();
    if (items.some((p) => p.id === province.id)) {
      throw new Error("Bu ID zaten var");
    }
    const next = [province, ...items];
    writeCollection(dbsKeys.provinces, next);
    return province;
  },

  update(id, patch) {
    const items = provincesRepo.list();
    const next = items.map((p) => (p.id === id ? { ...p, ...patch, id: p.id } : p));
    writeCollection(dbsKeys.provinces, next);
    return next.find((p) => p.id === id) || null;
  },

  remove(id) {
    const items = provincesRepo.list();
    const next = items.filter((p) => p.id !== id);
    writeCollection(dbsKeys.provinces, next);
  },
};
